import React from 'react'
import { Info } from '@mui/icons-material'
import { toast } from 'react-hot-toast'
import { UserDepositBonusModel } from 'mvppoker-portal-common/api'
import { MVPButton } from '../../Buttons/MVPButton'
import { MVPTextInput } from '../../TextInput/MVPTextInput'
import { ActiveUser } from '../../../state/reducers/activeUser'
import './WalletAddFundsModal.scss'

function PartWithoutWallet(props: { onClickAddWallet: () => void }) {
	return (
		<>
			<span className='modal-text'>
				You don&apos;t have a crypto wallet (ETH or BSC) assigned to your account.
				<br />
				Once you do you can make very cheap and fast direct crypto payments to add funds!
			</span>
			<MVPButton className='back-to-add-wallet-button' onClick={props.onClickAddWallet}>
				Back to Add Wallet
			</MVPButton>
		</>
	)
}

function PartWithWallet({ depositAddress }: { depositAddress: string }) {
	const onClickCopy = () => {
		if (!depositAddress) return
		navigator.clipboard.writeText(depositAddress).then(() => toast.success('Copied to Clipboard!'))
	}
	return (
		<>
			<span className='modal-text'> This is the Binance Smart Chain Wallet address to deposit funds to:</span>
			<MVPTextInput 
				id='wallet-address-label' 
				label='Wallet Address' 
				value={depositAddress} 
				disabled
			/>
			<MVPButton className='clear' onClick={onClickCopy}>
				Copy to Clipboard
			</MVPButton>
		</>
	)
}

export interface WalletAddFundsModalViewProps
{
	activeUser: ActiveUser
	depositBonus?: UserDepositBonusModel
	clickCryptoSevice: () => void
	clickCreditService: () => void
	clickAddWallet: () => void
	clickDepositBonus: () => void
}

export const WalletAddFundsModalView : React.FC<WalletAddFundsModalViewProps> = ({ activeUser, depositBonus, clickCryptoSevice, clickCreditService, clickAddWallet, clickDepositBonus }) =>
{
	const { config, wallet } = activeUser
	const hasWallet = wallet && wallet?.address !== '-'
	const showDepositBonus = depositBonus === undefined

	return (
		<>
			<span className='modal-title'>ADD FUNDS</span>
			{showDepositBonus && <MVPButton className='depositBonus' onClick={clickDepositBonus}>Deposit Bonus <Info/></MVPButton>}
			{hasWallet ? <PartWithWallet depositAddress={config?.depositWalletAddress ?? ''} /> : <PartWithoutWallet onClickAddWallet={clickAddWallet} />}
			<div className='h-divider'>
				<div className='h-divider-l' />
				<span>or</span>
				<div className='h-divider-r' />
			</div>
			<MVPButton onClick={clickCryptoSevice}>Deposit with Crypto or Cards</MVPButton>
			<div className='h-divider'>
				<div className='h-divider-l' />
				<span>or</span>
				<div className='h-divider-r' />
			</div>
			<MVPButton onClick={clickCreditService}>Deposit with Debit or Credit Card</MVPButton>
			<span className='modal-text-small disclaimer'>
				FUNDS MIGHT TAKE UP TO 2 HOURS TO SETTLE IN SOME RARE CASES
				<br />
				PLEASE TAKE THIS INTO CONSIDERATION WHEN PLANNING YOUR GAMES
			</span>
		</>
	)
}

